/** Shodný strop jako BE validátory příloh — uživatel dostane chybu ještě před odesláním. */
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;

/** Obsah souboru jako Base64 bez `data:` prefixu — v tomto tvaru ho čeká BE kontrakt. */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => resolve(String(reader.result).split(',', 2)[1] ?? '');
    reader.readAsDataURL(file);
  });
}
